import { Injectable } from '@angular/core'
import { BillingAddress } from '@tokeet/tv3-platform'
import { MatDialog, MatDialogConfig } from '@angular/material/dialog'
import { BillingAddressDialogComponent } from './billing-address-dialog.component'

@Injectable({
  providedIn: 'root',
})
export class BillingAddressDialogService {
  constructor(private dialog: MatDialog) {}

  open(address?: BillingAddress) {
    const defaultConfig: MatDialogConfig = {
      width: '650px',
      height: 'auto',
      panelClass: ['variable-modal'],
      data: { address },
    }

    return this.dialog.open(BillingAddressDialogComponent, defaultConfig)
  }
}
